import {
  isPrimitive,
  isPrimitiveArray,
  isPrimitiveMap,
} from '@smartsheet-dataflow/formjs';
import isNil from 'lodash/fp/isNil';
import { ParamModel } from '../params/ParamModelTypes';
import { ModuleModel } from './ModuleModelTypes';

export const flattenModel = (model: ModuleModel | undefined): ParamModel => {
  if (isNil(model)) {
    return {};
  }

  return Object.keys(model).reduce((params, key) => {
    const paramValue = model[key].value;
    if (isNil(paramValue)) {
      return params;
    } else if (
      isPrimitive(paramValue) ||
      isPrimitiveArray(paramValue) ||
      isPrimitiveMap(paramValue)
    ) {
      return { ...params, [key]: paramValue };
    } else if (Array.isArray(paramValue)) {
      return { ...params, [key]: paramValue.map(flattenModel) };
    } else {
      return { ...params, [key]: flattenModel(paramValue) };
    }
  }, {});
};
